module.exports = "https://r.zoocdn.com/_next/static/images/envelope-7d575047dec0c1f68978463b29db9921.svg";